import React from 'react';
import { useNavigate } from 'react-router-dom';
import manufacture from '../Images/P-1.png';
import travel from '../Images/P-2.png';
import electric from '../Images/P-3.png';

const Projects = () => {
    const navigate = useNavigate()
    return (
        <div className='mb-5 mt-5' id='projectsection' data-aos="fade-up"
        data-aos-offset="300"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="2000">
            <h1 className='text-3xl font-bold text-center mb-10'>LATEST <span className='text-orange-400'>PROJECTS</span></h1>
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-5' >
                {/* card-1 */}
                <div class="card w-full bg-base-100 shadow-2xl transform transition-all hover:scale-105" >
                    <figure class="px-10 pt-10">
                        <img src={manufacture} alt="Shoes" class="rounded-xl" />
                    </figure>
                    <div class="card-body items-center text-center">
                        <h2 class="card-title text-orange-400 font-bold">Computer Parts Manufacturer</h2>
                        <p>A full stack parts manufacurer company website</p>
                        <div class="card-actions">
                            <button class="btn">Live View</button>
                            <button onclick="{()=>window.open('https://computer-parts-manufactu-88a04.web.app/')}" class="btn">See Detail</button>
                        </div>
                    </div>
                </div>
                {/* card-2 */}
                <div class="card w-full bg-base-100 shadow-2xl transform transition-all hover:scale-105">
                    <figure class="px-10 pt-10">
                        <img src={travel} alt="Shoes" class="rounded-xl" />
                    </figure>
                    <div class="card-body items-center text-center">
                        <h2 class="card-title text-orange-400 font-bold">Travel Guider</h2>
                        <p>A travel guide website</p>
                        <div class="card-actions">
                            <button class="btn">Live View</button>
                            <button onClick={() => navigate('/projects')} class="btn">See Detail</button>
                        </div>
                    </div>
                </div>
                {/* card-3 */}
                <div class="card w-full bg-base-100 shadow-2xl transform transition-all hover:scale-105">
                    <figure class="px-10 pt-10">
                        <img src={electric} alt="Shoes" class="rounded-xl" />
                    </figure>
                    <div class="card-body items-center text-center">
                        <h2 class="card-title text-orange-400 font-bold">Electronics Warehouse</h2>
                        <p>Warehouse inventory management website</p>
                        <div class="card-actions">
                            <button class="btn">Live View</button>
                            <button onClick={() => navigate('/projects')} class="btn">See Detail</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Projects;